import * as React from 'react';
import { Banner, Friends } from '../components';

export const OssFriends = () => (
  <>
    <Banner />
    <Friends />
  </>
);

export default OssFriends;
